import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const rootUrl = ''

export default new Vuex.Store({
  state: {
    uEditorServerUrl: rootUrl + '/ueditor/upload/',
    api: rootUrl,
    rootUrl: rootUrl + '/',
    userInfo: {
      profile_id: 0,
      user_name: '',
      name: '',
      avatar: '',
      gender: '',
      mobile: '',
      mobile_status: '',
      role: '',
      province: '',
      school_id: '',
      school_name: '',
      academy_id: '',
      academy_name: '',
      major_id: '',
      major_name: ''
    },
    flashList: [],
    token: '',
    defaultImg: 'this.src="' + require('@/assets/images/default.jpg') + '"',
    defaultHeadImg: 'this.src="' + require('@/assets/images/user.png') + '"',
    login_time: 0,
    dict_platform_level: {
      1: '国家',
      2: '省',
      3: '校',
      4: '院'
    },
    platform_level: 4,
    orgInfo: {
      name: '版权所有：北京交通大学',
      code: '京公网安备：110402430059    京ICP备12010520号-2'
    },
    dict_role: {
      0: '超级管理员',
      2: '省管理员',
      3: '校管理员',
      4: '院系管理员',
      10: '运营管理员',
      11: '教师',
      12: '学生'
    },
    dict_province: {
      0: '北京市',
      1: '天津市',
      2: '河北省',
      3: '山西省',
      4: '内蒙古自治区',
      5: '辽宁省',
      6: '吉林省',
      7: '黑龙江省',
      8: '上海市',
      9: '江苏省',
      10: '浙江省',
      11: '安徽省',
      12: '福建省',
      13: '江西省',
      14: '山东省',
      15: '河南省',
      16: '湖北省',
      17: '湖南省',
      18: '广东省',
      19: '广西壮族自治区',
      20: '海南省',
      21: '重庆市',
      22: '四川省',
      23: '贵州省',
      24: '云南省',
      25: '西藏自治区',
      26: '陕西省',
      27: '甘肃省',
      28: '青海省',
      29: '宁夏回族自治区',
      30: '新疆维吾尔自治区',
      31: '新疆生产建设兵团',
      32: '香港特别行政区',
      33: '澳门特别行政区',
      34: '台湾省',
      35: '军队本科高校'
    },
    dict_experiment_state: {
      1: '填报中',
      2: '待学院审核',
      3: '学院审核未通过',
      4: '待学校审核',
      5: '学校审核未通过',
      6: '待省管理员审核',
      7: '省管理员审核未通过',
      8: '已通过审核',
      9: '已发布'
      // 8: '待系统管理员审核',
      // 9: '系统管理员未通过',
      // 10: '待发布',
      // 11: '已发布'
    },
    sb_state: {
      1: '待定级',
      2: '已完成推荐'
    },
    dict_course_state: {
      0: '建设中',
      1: '待审核',
      2: '待发布',
      3: '不通过',
      4: '已撤销',
      5: '已发布'
    },
    dict_course_type: {
      1: '在线课程'
    },
    dict_resource_type: {
      1: '文本类',
      2: '微课类',
      3: '图形/图像类',
      4: '音频类',
      5: '视频类',
      6: '动画类',
      7: '虚拟仿真类',
      8: 'PPT演示文稿',
      9: '网页课件',
      10: '富媒体',
      11: '其他'
    },
    dict_basic_Lang: {
      1: '中文',
      2: '英文',
      3: '双语',
      4: '其他'
    },
    dict_exp_level: {
      1: '国家级',
      2: '省级',
      3: '校级'
    },
    dict_auth_exp_level: {
      1: '国家级',
      2: '省级',
      3: '校级',
      4: '未定级'
    },
    dict_info_category: {
      1: '通知公告',
      2: '新闻资讯',
      3: '资料下载'
    },
    dict_school_level: {
      1: '本科',
      2: '高职',
      3: '中职'
    },
    dict_exp_type: {
      1: '基础练习型',
      2: '综合设计型',
      3: '研究探索型',
      4: '其他'
    },
    dict_exp_language: {
      1: '中文',
      2: '中文+外文字幕（语种）',
      3: '外文（语种）'
    },
    dict_log_type: {
      1: '登录',
      2: '进行实验',
      3: '课程学习'
    },
    dict_info_source: {
      1: '原创',
      2: '转载'
    },
    dict_level_info: {
      2: '省',
      3: '校',
      4: '其他'
    },
    max_file_size: 1024 * 1024 * 1024,
    historyList: []
  },
  mutations: {
    setUserInfo(state, userInfo) {
      this.state.userInfo = userInfo
    },
    clearUserInfo(state) {
      this.state.userInfo = {
        profile_id: 0,
        user_name: '',
        name: '',
        avatar: '',
        gender: '',
        mobile: '',
        mobile_status: '',
        role: '',
        province: '',
        school_id: '',
        school_name: '',
        academy_id: '',
        academy_name: '',
        major_id: '',
        major_name: ''
      }
    },
    setToken(state, token) {
      this.state.token = token
    },
    setHistory(state, history) {
      const index = this.state.historyList.indexOf(history)
      if (this.state.historyList.length > 5) {
        this.state.historyList.shift()
      }
      if (index < 0) {
        this.state.historyList.push(history)
      }
    },
    setSensitiveWord(state, word) {
      this.state.dict_words = word
    },
    setLoginTime(state, timestamp) {
      this.state.login_time = timestamp
    },
    setFlashList(state, list) {
      this.state.flashList = list
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState({ storage: window.localStorage })]
})
